import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import { PlusIcon } from "icons/solid";
import { IconButton } from "ui";
import { axiosApiInstance } from "../pages/api/axios";
import Drawer from "./Drawer";
import { TableFormResponse } from "./Table/types";
const DynamicForm = dynamic(() => import("./DynamicForm"));

type AddPopOverFormProps = {
  url: string;
  entityName: string;
  customForm?: React.ReactNode;
  title: React.ReactNode;
  onSuccess: (name: string, data: any) => void;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const AddPopOverForm: React.FC<AddPopOverFormProps> = ({
  url,
  customForm,
  title,
  onSuccess,
  open,
  setOpen,
  entityName,
}) => {
  const [formFields, setFormFields] = useState<
    TableFormResponse["data"]["form_fields"]
  >([]);

  useEffect(() => {
    if (url) {
      return fetchForm(url);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function fetchForm(url: string) {
    axiosApiInstance.get(url).then((response) => {
      setFormFields(
        (response.data as TableFormResponse).data.form_fields.filter(
          ({ read_only }) => !read_only
        )
      );
    });
  }

  return (
    <React.Fragment>
      {!customForm && (
        <IconButton onClick={() => setOpen(true)}>
          <PlusIcon className="h-4 w-4" aria-hidden="true" />
        </IconButton>
      )}
      <Drawer isOpen={open} onClose={() => setOpen(false)} title={title}>
        <Drawer.Content className="divide-y divide-neutral-700 p-8 pb-0">
          {customForm ? (
            customForm
          ) : (
            <DynamicForm
              fields={formFields}
              submitURL={url}
              onSuccess={(
                name: string,
                data: {
                  preview: Record<string, any>;
                  columns: Record<string, any>;
                }
              ) => {
                setOpen(false);
                onSuccess(name, data);
              }}
              onCancel={() => setOpen(false)}
              entityName={entityName}
              editForm={undefined}
            />
          )}
        </Drawer.Content>
      </Drawer>
    </React.Fragment>
  );
};

export default AddPopOverForm;
